$(document).ready(function(){
  
  $(window).on("scroll resize", function(){
     if($(window).width() < 767) {
       var div = $('.tom_quntity_with_atc').offset().top;
       var windowpos = $(window).scrollTop(); 
       if(windowpos > div){
          $(".tom_mobile_bottom_stc_fix_content").removeClass("none-atc_fix_product_part");
          $(".tom_mobile_bottom_stc_fix_content").addClass("show-atc_fix_product_part");
        }else{
          $(".tom_mobile_bottom_stc_fix_content").removeClass("show-atc_fix_product_part");
          $(".tom_mobile_bottom_stc_fix_content").addClass("none-atc_fix_product_part");
        }
       }else{
         $(".tom_mobile_bottom_stc_fix_content").removeClass("show-atc_fix_product_part");
       } 
  });
});